<template>
  <div class="home-page d-flex min-vh-100">
    <PreLoading />
    <!-- <CContainer fluid>
      <CRow>
        <CCol>
          <CHeader fixed with-subheader light class="header-nav">
            <CHeaderBrand class="mx-auto site_logo" to="/">
              <img
                src="@/assets/icons/logoLR_yoko.svg"
                height="48"
                class="img-fluid"
                alt="Liberty"
              />
            </CHeaderBrand>
          </CHeader>
        </CCol>
      </CRow>

      <CRow
        class="cover_section justify-content-center my-0 min-vh-100"
        :style="{
          'background-image':
            'url(' + require('../assets/images/kunozan.jpg') + ')',
        }"
      >
        <CCol>
          <CRow class="w-100 justify-content-center">
            <CCol lg="12" >
              <CContainer class="d-flex content-center min-vh-100">
                <CRow>
                  <CCol class="text-white">
                    <h1>ログアウトしました</h1>
                    <h4 class="pt-3">再度ログインはこちら</h4>
                    <CButton
                      color="info"
                      class="px-5 m-5"
                      to="home"
                    >
                      ホーム
                    </CButton>
                    <CButton
                      color="success"
                      class="px-5 m-5"
                      v-on:click="goLogin"
                    >
                      ログイン
                    </CButton>
                  </CCol>
                </CRow>
              </CContainer>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </CContainer> -->
  </div>

</template>

<script>
export default {
  name: "Logout",
  beforeMount() {
    this.performLogout();
  },
  methods: {
    goLogin: function () {
      this.$router.push("/home");
    },
    performLogout: function () {
      console.log(this.$keycloak.$data);
      if (this.$keycloak.authenticated) {
        if (this.$keycloak.logoutFn) {
          this.$keycloak.logoutFn();
        }
      }
      this.goLogin();
    },
  },
};
</script>
